module.exports = __webpack_public_path__ + "front/img/28.f08e8930.png";